(function(){
  'use strict';
  if(window.__PMY_HEADER_CONTROLS_FINAL__)return;
  window.__PMY_HEADER_CONTROLS_FINAL__=true;

  var GLOBE='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M3 12h18"></path><path d="M12 3a15 15 0 0 1 0 18"></path><path d="M12 3a15 15 0 0 0 0 18"></path></svg>';

  function isDark(){
    return document.documentElement.getAttribute('data-bs-theme')==='dark';
  }

  function syncLogos(){
    var mobile=window.matchMedia('(max-width:767px)').matches;
    document.querySelectorAll('.main-header-wrapper').forEach(function(root){
      var lightD=root.querySelector('.logo-claro-desktop');
      var darkD=root.querySelector('.logo-noturno-desktop');
      var lightM=root.querySelector('.logo-claro-mobile');
      var darkM=root.querySelector('.logo-noturno-mobile');
      var dark=isDark();

      [lightD,darkD,lightM,darkM].forEach(function(img){
        if(!img)return;
        img.style.setProperty('display','none','important');
        img.style.setProperty('visibility','hidden','important');
        img.style.setProperty('opacity','0','important');
        img.style.setProperty('position','absolute','important');
        img.style.setProperty('pointer-events','none','important');
      });

      var target=mobile?(dark?darkM:lightM):(dark?darkD:lightD);
      if(!target){
        target=mobile?(lightM||darkM):(lightD||darkD);
      }
      if(target){
        target.style.setProperty('display','block','important');
        target.style.setProperty('visibility','visible','important');
        target.style.setProperty('opacity','1','important');
        target.style.setProperty('position','static','important');
        target.style.setProperty('pointer-events','auto','important');
      }
    });
  }

  function normalizeLanguageButtons(){
    document.querySelectorAll('.main-header-wrapper .language-selector-wrapper').forEach(function(wrap){
      var btn=wrap.querySelector('.pmy-lang-globe,.language-toggle,.custom-lang-toggle');
      if(!btn)return;
      btn.type='button';
      btn.classList.add('pmy-lang-globe');
      if(!btn.querySelector('svg'))btn.innerHTML=GLOBE;
      btn.style.pointerEvents='auto';
      btn.removeAttribute('disabled');
    });
  }

  function openLanguage(){
    var modal=document.getElementById('pmy-language-region-modal');
    if(!modal)return false;
    document.body.appendChild(modal);
    document.documentElement.classList.add('pmy-lang-open');
    document.body.classList.add('pmy-lang-open');
    modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-open');
    setTimeout(function(){
      var close=modal.querySelector('.pmy-lang-close');
      if(close)close.focus();
    },20);
    return true;
  }

  function toggleTheme(){
    var next=isDark()?'light':'dark';
    document.documentElement.setAttribute('data-bs-theme',next);
    try{localStorage.setItem('theme',next)}catch(e){}
    try{localStorage.setItem('pmy_theme',next)}catch(e){}
    syncLogos();
    document.dispatchEvent(new CustomEvent('pmy:theme-change',{detail:{theme:next}}));
  }

  document.addEventListener('click',function(e){
    var themeBtn=e.target.closest&&e.target.closest('.main-header-wrapper .mode-switcher-btn,.main-header-wrapper .btn-theme-toggle');
    if(themeBtn){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleTheme();
      return;
    }

    var langBtn=e.target.closest&&e.target.closest('.main-header-wrapper .pmy-lang-globe,.main-header-wrapper .language-toggle,.main-header-wrapper .custom-lang-toggle');
    if(langBtn){
      if(openLanguage()){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  },true);

  var themeObserver=new MutationObserver(function(mutations){
    if(mutations.some(function(m){return m.type==='attributes'&&m.attributeName==='data-bs-theme'})){
      syncLogos();
    }
  });
  themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-bs-theme']});

  function refresh(){
    normalizeLanguageButtons();
    syncLogos();
  }

  window.addEventListener('resize',refresh,{passive:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(refresh,0)});
  document.addEventListener('shopify:section:reorder',function(){setTimeout(refresh,0)});

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',refresh,{once:true});
  }else{
    refresh();
  }

  setTimeout(refresh,150);
  setTimeout(refresh,800);
})();